

// Helper: update ATC button price based on current subscription/quantity selection
function updateAtcPrice(parentForm) {
    const atcButton = parentForm.querySelector('.button[type="submit"] .atc-price');
    const quantity = parentForm.querySelector('input[name="quantity"]:checked')?.value || 1;
    const checkedPlan = parentForm.querySelector('input[name="selling_plan"]:checked');
    const price = checkedPlan?.dataset.price;

    if (atcButton && price) {
        const finalPrice = theme.Currency.formatMoney(price * quantity, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat);
        atcButton.innerHTML = finalPrice;
    }
}

// Helper: update per drink price
function updatePerDrinkPrice(parentForm) {
    const perDrinkEl = parentForm.querySelector('.per-drink');
    const servingsPerPack = perDrinkEl?.dataset.drinksPerPack;
    const checkedPlan = parentForm.querySelector('input[name="selling_plan"]:checked');
    const price = checkedPlan?.dataset.price;

    if (perDrinkEl && servingsPerPack && price) {
        const costPerDrink = theme.Currency.formatMoney(price / Number(servingsPerPack), theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat);
        perDrinkEl.querySelector('span').innerHTML = costPerDrink;
    }
}

// Helper: update subscription/otp prices in the selector (for quantity changes)
function updateSubscriptionPrices(parentForm) {
    const quantity = parentForm.querySelector('input[name="quantity"]:checked')?.value || 1;
    const subInput = parentForm.querySelector('input[name="selling_plan"][id*="subscribe"]');
    const otpInput = parentForm.querySelector('input[name="selling_plan"][id*="otp"]');

    const subPrice = subInput?.dataset.price;
    const otpPrice = otpInput?.dataset.price;

    if (subPrice) {
        const subPriceEls = parentForm.querySelectorAll('.subscription-price');
        subPriceEls.forEach(el => el.innerHTML = theme.Currency.formatMoney(subPrice * quantity, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat));
    }

    if (otpPrice) {
        const otpPriceEls = parentForm.querySelectorAll('.otp-price');
        otpPriceEls.forEach(el => el.innerHTML = theme.Currency.formatMoney(otpPrice * quantity, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat));
    }
}

// Helper: toggle best value / discount text
function toggleDiscountText(parentForm) {
    const isOtp = parentForm.querySelector('input[name="selling_plan"]:checked')?.value == "";
    const popularTextEls = parentForm.querySelectorAll('.popular-text');
    const discountTextEls = parentForm.querySelectorAll('.discount-text');

    if (isOtp) {
        popularTextEls.forEach(el => el.classList.add('hidden'));
        discountTextEls.forEach(el => el.classList.remove('hidden'));
    } else {
        popularTextEls.forEach(el => el.classList.remove('hidden'));
        discountTextEls.forEach(el => el.classList.add('hidden'));
    }
}

// Use event delegation so handlers survive HTML swaps on variant change
document.addEventListener('change', function(e) {
    // Handle subscription/OTP radio button changes
    if (e.target.matches('.subscription-selector input[name="selling_plan"]')) {
        const parentForm = e.target.closest('form');
        if (!parentForm) return;

        updateAtcPrice(parentForm);
        updatePerDrinkPrice(parentForm);
        toggleDiscountText(parentForm);
    }

    // Handle quantity selector changes
    if (e.target.matches('input[name="quantity"]')) {
        const parentForm = e.target.closest('form');
        if (!parentForm) return;

        updateAtcPrice(parentForm);
        updatePerDrinkPrice(parentForm);
        updateSubscriptionPrices(parentForm);
    }
});

// Listen for variant changes to update ATC price after subscription selector HTML is swapped
if (typeof theme !== 'undefined' && theme.pubsub) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
        const { sectionId, productId } = event.data;
        const productForm = document.querySelector(`#ProductForm-${sectionId}-${productId}`);
        if (!productForm) return;

        // After the subscription selector HTML has been swapped by the theme,
        // update the ATC button price to match the new variant's subscription price
        updateAtcPrice(productForm);
        updatePerDrinkPrice(productForm);
    });
}

